import React from 'react';
import { NAVY, TEAL, LIGHT_BLUE, MAUVE, SLATE } from './palette';
import { fmtValue } from './format';

// Strip plot of one statistic across a set of funds: quantile ticks, an optional
// benchmark line, on-screen funds in teal, selected funds in navy.
export default function DistributionStrip({ title, note, unit, points, quantiles, benchmark, selected, onScreen }) {
  if (!points || !points.length) return null;
  const sel = selected || new Set();
  const scr = onScreen || new Set(points.map((p) => p.tr));
  const vals = points.map((p) => p.v);
  let lo = Math.min(...vals); let hi = Math.max(...vals);
  if (benchmark !== null && benchmark !== undefined) { lo = Math.min(lo, benchmark); hi = Math.max(hi, benchmark); }
  if (hi === lo) { hi += 1e-6; lo -= 1e-6; }
  // Wide viewBox so text and dots stay small when the SVG is stretched to the tile width.
  const W = 1200; const H = 92; const padX = 16;
  const x = (v) => padX + (v - lo) / (hi - lo) * (W - 2 * padX);
  const jitter = (i) => 40 + ((i * 37) % 31) - 15;
  const q = quantiles || {};
  return (
    <div className="qs-tile qs-tile-wide">
      <div className="qs-tile-title">{title}{note && <span className="qs-muted"> {note}</span>}</div>
      <svg viewBox={`0 0 ${W} ${H}`} className="qs-strip" role="img" aria-label="distribution strip">
        <line x1={padX} x2={W - padX} y1={H - 20} y2={H - 20} stroke={LIGHT_BLUE} />
        {['p10', 'p25', 'p50', 'p75', 'p90'].filter((k) => q[k] !== null && q[k] !== undefined).map((k) => (
          <g key={k}>
            <line x1={x(q[k])} x2={x(q[k])} y1={H - 25} y2={H - 15} stroke={SLATE} />
            <text x={x(q[k])} y={H - 4} fontSize={11} textAnchor="middle" fill="#7F7F7F">{k}</text>
          </g>
        ))}
        {benchmark !== null && benchmark !== undefined && (
          <g>
            <line x1={x(benchmark)} x2={x(benchmark)} y1={14} y2={H - 20} stroke={MAUVE} strokeDasharray="4 3" />
            <text x={x(benchmark)} y={11} fontSize={11} textAnchor="middle" fill={MAUVE}>benchmark</text>
          </g>
        )}
        {points.map((p, i) => {
          const isSel = sel.has(p.tr);
          const isScr = scr.has(p.tr);
          return (
            <circle key={p.tr} cx={x(p.v)} cy={jitter(i)} r={isSel ? 6 : (isScr ? 4 : 3)}
              fill={isSel ? NAVY : (isScr ? TEAL : LIGHT_BLUE)} opacity={isSel ? 1 : 0.8}>
              <title>{`${p.name || p.tr}: ${fmtValue(p.v, unit)}${p.held ? ' (held)' : ''}`}</title>
            </circle>
          );
        })}
        <text x={padX} y={H - 4} fontSize={11} fill="#7F7F7F">{fmtValue(lo, unit)}</text>
        <text x={W - padX} y={H - 4} fontSize={11} textAnchor="end" fill="#7F7F7F">{fmtValue(hi, unit)}</text>
      </svg>
    </div>
  );
}
